import React, { Component } from 'react';
import mailVerifyResult from './../email-verify-result.js';

class EmailVerifyResult extends Component {
	componentWillMount() {
		const param = this.props.match.params[0];
		mailVerifyResult.setActive(true, param);
	}

	componentWillUnmount() {
		mailVerifyResult.setActive(false);

	}

	render() {
		return (
			<div id="mail-verify-result" />
		);
	}
}

export default EmailVerifyResult;



// WEBPACK FOOTER //
// ./mobile-core/src/components/email-verify-result.js